import styled from 'styled-components';

export const Container = styled.div<{ $disabled?: boolean }>`
  position: relative;
  display: inline-block;
  text-align: left;
  opacity: 1;
  border-radius: 14px;
  transition: opacity 0.25s ease 0s;
  touch-action: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  user-select: none;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;

export const Text = styled.span`
  position: absolute;
  width: 100%;
  height: 26px;
  text-align: center;
  font-weight: normal;
  top: 8px;
  transition: 300ms ease;
`;

export const Handle = styled.div<{ $disabled?: boolean; $checked: boolean }>`
  height: 32px;
  width: 32px;
  background: ${({ theme, $disabled }) => theme[$disabled ? 'backgroundLightest' : 'white']};
  display: inline-block;
  border-radius: 50%;
  position: absolute;
  top: 20px;
  z-index: 1;
  transform: translate(${({ $checked }) => ($checked ? 42 : 4)}px, -50%);
  transition:
    background-color 0.25s ease 0s,
    transform 0.25s ease 0s,
    box-shadow 0.15s ease 0s;
`;

export const Input = styled.input`
  border: 0;
  clip: rect(0px, 0px, 0px, 0px);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const Bg = styled.div<{ $disabled?: boolean; $checked: boolean }>`
  height: 40px;
  width: 80px;
  position: relative;
  background: ${({ $checked, theme, $disabled }) =>
    $disabled ? theme.backgroundMid : theme[$checked ? 'primary' : 'lightGrey']};
  border-radius: 20px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: background 0.25s ease 0s;
`;
